import { Component, inject, Input } from '@angular/core';
import {
  WagtailContentTileRendererInterface,
  WagtailPageContentElementInterface,
  WagtailTilesRendererInterface
} from "@gea-waldviertler-website/gea-models";
import { ImageFactory } from "@gea-waldviertler-website/gea-models";
import { EnvService } from "@gea-waldviertler-website/shop-lib";

@Component({
    selector: 'wagtail-page-element-tiles',
    templateUrl: './tiles.component.html',
    standalone: false
})
export class WagtailTilesComponent {

  @Input() definition?: WagtailPageContentElementInterface<WagtailTilesRendererInterface>
  imageRoot: string
  private envService = inject(EnvService)

  constructor() {
    this.imageRoot = this.envService.config.cmsMediaUrl + "/"
  }

  getImagePath(tile: WagtailContentTileRendererInterface): string {
    const size = 1320 / (this.definition?.value.columns || 2)
    const image = ImageFactory.getImageByHeight(tile.value.picture_tag_info, size)

    return this.imageRoot + (image ? image.path.replace(/^\/media/, '') : tile.value.picture_tag_info.path)
  }
}
